import { __rest } from "tslib";
import React from 'react';
import { useConfiguration } from '../../../../context/configuration-context/use-configuration';
import SubmitButton from './submit-button';
const PublishSelectLazy = React.lazy(() => import(/* webpackChunkName: "wc-publish-select" */ './publish-select'));
const PublishSelectAsync = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { screenshotMode } = useConfiguration();
    // preload with screenshotMode for sled tests
    const [state, setState] = React.useState({
        isLoaded: !!screenshotMode,
        shouldShowOnMount: false,
    });
    const Button = () => (React.createElement("div", { onKeyDown: (e) => e.key === 'Enter' &&
            setState({
                isLoaded: true,
                shouldShowOnMount: true,
            }), onClick: () => setState({
            isLoaded: true,
            shouldShowOnMount: true,
        }), onMouseEnter: () => setState({
            isLoaded: true,
            shouldShowOnMount: false,
        }) },
        React.createElement(SubmitButton, { disabled: props.disabled }, children)));
    return state.isLoaded ? (React.createElement(React.Suspense, { fallback: React.createElement(Button, null) },
        React.createElement(PublishSelectLazy, Object.assign({}, props, { showOnMount: state.shouldShowOnMount }), children))) : (React.createElement(Button, null));
};
export default PublishSelectAsync;
//# sourceMappingURL=publish-select-async.js.map